/*!
 * jQuery lightweight plugin boilerplate
 * Original author: @ajpiano
 * Further changes, comments: @addyosmani
 * Licensed under the MIT license
 */

;(function ( $, window, document, undefined ) {

    // Create the defaults once
    var pluginName = 'beInputList',
        defaults = {
            propertyName: "value"
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);
        this.options = $.extend( {}, defaults, options) ;
        this._mxConversionRate = 20;
        this._defaults = defaults;
        this._name = pluginName;

        this.template = $(element).find('.js-beInputList__tmp');

        this.init();
    }

    Plugin.prototype.init = function () {

        var Plugin = this;

        $(Plugin.element).find('.js-beInputList__new').on('click',function (e) {

            var valid = true;

            $.each($(this).parent().parent().find('input'),function () {
                if($(this).val()){
                    valid = true;
                }
                else{
                    valid = false;
                    return false;
                }
            });

            if(valid === true){

                $.each($(this).parent().parent().find('input'),function () {
                    $(this).removeClass('is-invalid-input');
                });

                //$(this).addClass('hide');

                //$(this).next('.js-asignature__edit').removeClass('hide');

                var tmp = $(Plugin.element).find('.js-beInputList__tmp').html();

                $(tmp).find('select').attr('class',$(this).attr('class'));
                // tmp = $(this).find('.row').html()
                // $(this).addClass-('disabled');
                $(Plugin.element).append(tmp);

                Plugin.init();
            }
            else{
                $.each($(this).parent().parent().find('input'),function () {
                    $(this).addClass('is-invalid-input');
                });
            }

            var url = window.location.origin;

            $(Plugin.element).find('.row').last().find('select.js-autocomplete').select2({
                allowClear: true,
                ajax: {
                    url: url + '/productos/list',
                    dataType: 'json',
                    delay: 250,
                    method: 'GET',
                    async: false,
                    data: function (params) {
                        return {
                            search: {name:params.term}, // search term
                            page: params.page
                        };
                    },
                    processResults: function (data, params) {

                        params.page = params.page || 1;

                        if(data.data){
                            return {
                                results: $.map(data.data, function (item) {
                                    return {
                                        text: item.reference + ' - ' + item.name + ' - ' + item.price + '€',
                                        slug: item.locale,
                                        id: item.id,
                                        price: item.price,
                                        mxPrice: item.mx_price
                                    }
                                }),
                                pagination: {
                                    more: (params.page * 15) < data.total
                                }
                            };
                        }
                        else{
                            return {
                                results: $.map(data, function (item) {
                                    return {
                                        text: item.reference + ' - ' + item.name + ' - ' + item.price + '€',
                                        slug: item.locale,
                                        id: item.id,
                                        mxPrice: item.mx_price
                                    }
                                }),
                                pagination: {
                                    more: (params.page * 15) < data.total_count
                                }
                            };
                        }
                    },
                    cache: true
                }
            });

            $('.select2-container + .select2-container').remove();

        });

        Plugin.setEvents();

        $(Plugin.element).find('.js-beInputList__edit').on('click',function(e){
            $(this).closest('.row').remove();
            // $(Plugin.element).find('.js-beInputList__new').first().removeClass('disabled')

            if(!$(Plugin.element).find('>.row')[0]){

                var tmp = $(Plugin.element).find('.js-beInputList__tmp').html();

                $(tmp).find('select').attr('class',$(this).attr('class'));

                $(Plugin.element).append(tmp);

                Plugin.init();

                Plugin.loadSelect();
            }
        });

    };

    Plugin.prototype.loadSelect = function(){

        var Plugin = this;

        $('select.js-autocomplete').select2({
            allowClear: true,
            ajax: {
                url: url + '/productos/list',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.reference + ' - ' + item.name + ' - ' + item.price + '€',
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.reference + ' - ' + item.name + ' - ' + item.price + '€',
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

    };

    Plugin.prototype.setEvents = function() {
        var Plugin = this;
        var inputPriceEu = $(Plugin.element).find('.js-beInputList__price');
        var inputPriceMx = $(Plugin.element).find('.js-beInputList__mx-price');

        inputPriceEu.on('input change ', function() {
            Plugin.convertMx($(this), $(this).parent().parent().find('.js-beInputList__mx-price'))
        });

        inputPriceMx.on('input change ', function() {
          Plugin.convertEu($(this).parent().parent().find('.js-beInputList__price'), $(this))
        })

        Plugin.changePrices();
    }

    Plugin.prototype.changePrices = function() {
    var price;
    var mxPrice;

    $(".js-autocomplete-products , .js-autocomplete").on('change.select2', function () {
      var data = $(this).select2('data')[0];
      var inputPriceEu = $(this).parent().parent().find('.js-beInputList__price').val(price);
      var inputPriceMx = $(this).parent().parent().find('.js-beInputList__mx-price').val(mxPrice);

      price = parseFloat((data.price.replace('.','')).replace(',','.'));
      mxPrice = parseFloat(data.mxPrice.replace('.',''));

      inputPriceMx.val(mxPrice)
      inputPriceEu.val(price)

    })
  };

    Plugin.prototype.convertMx = function(inputPriceEu, inputPriceMx) {
      var Plugin = this;
        var $priceEu = parseFloat(inputPriceEu.val());
        var $priceMx = $priceEu * Plugin._mxConversionRate;
        inputPriceMx.val($priceMx)
    }

    Plugin.prototype.convertEu = function(inputPriceEu, inputPriceMx) {
      var Plugin = this;
        var $priceMx = parseFloat(inputPriceMx.val());
        var $priceEu = $priceMx / Plugin._mxConversionRate;
        inputPriceEu.val($priceEu)
    }

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );